// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableView-x {
  .add-row,
  .sort-button {
    align-items: center;
    color: #757575;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    padding: 0.25rem 0.75rem;
    width: 100%;

    &:hover {
      background-color: #eeeeee;
    }
  }

  .add-row {
    color: #9e9e9e;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    font-weight: 500;
    padding: 0.5rem;
    border-bottom: 1px solid #e0e0e0;

    &:hover {
      background-color: #e9e9e9;
    }
  }

  .bg-white {
    background-color: white;
  }

  .border-radius-md {
    border-radius: 5px;
  }

  .cell-padding {
    padding: 0.5rem;
  }

  .cursor-default {
    cursor: default;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .data-input {
    background-color: white;
    border: none;
    box-sizing: border-box;
    color: #424242;
    flex: 1 1 auto;
    font-size: 0.8rem;
    height: 100%;
    padding: 0.5rem;
    resize: none;
    white-space: pre-wrap;
    width: 100%;
  }

  .d-flex {
    display: flex;
  }

  .flex-1 {
    flex: 1;
  }

  .flex-wrap-wrap {
    flex-wrap: wrap;
  }

  .font-size-75 {
    font-size: 0.75rem;
  }

  .font-weight-600 {
    font-weight: 600;
  }

  .form-input {
    background-color: #eeeeee;
    border: none;
    color: #424242;
    font-size: 14px;
    padding: 0.375rem;
    /* border-radius: 4px; */
  }

  .form-input:focus {
    box-shadow: 0 0 1px 2px #8ecae6;
    outline: none;
  }

  .icon-margin {
    margin-right: 4px;
  }

  .is-fullwidth {
    width: 100%;
  }

  .noselect {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .option-input,
  .transition-fade-enter,
  .transition-fade-exit {
    background-color: transparent;
    border: none;
    font-size: 1rem;
    outline: none;
    width: 100%;
  }

  .overlay {
    height: 100vh;
    left: 0;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 2;
  }

  .resizer {
    background: transparent;
    cursor: col-resize;
    display: inline-block;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    touch-action: none;
    transform: translateX(50%);
    width: 8px;
    z-index: 1;

    &:hover {
      background-color: #8ecae6;
    }
  }

  .shadow-5 {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.12),
      0 4px 6px rgba(0, 0, 0, 0.12), 0 8px 16px rgba(0, 0, 0, 0.12), 0 16px 32px rgba(0, 0, 0, 0.12);
  }

  .svg-gray svg {
    stroke: #9e9e9e;
  }

  .svg-green {
    color: #3e9140;
  }

  .svg-icon svg,
  .svg-icon-sm svg,
  .svg-180 svg,
  .svg-text svg {
    height: 1.5em;
    position: relative;
    width: 1.5em;
  }

  .svg-icon-sm svg {
    height: 1.25em;
    width: 1.25em;
  }

  .table {
    border-spacing: 0;
    margin-bottom: 10px;
  }

  .tableHeader {
    background-color: #f5f5f5;
    display: flex;
  }

  .text-align-right {
    text-align: right;
  }

  .th,
  .td {
    border-bottom: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    margin: 0;
  }

  .th-content {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-self: center;
    padding: 0.5rem;
    white-space: normal;

    .subLabel {
      color: #5f5f5f;
      font-size: 0.75rem;
      word-wrap: break-word;
      width: 100%;
    }
  }

  thead {
    display: flex;
  }

  .th {
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 500;
    overflow: hidden;
    position: relative;
    white-space: nowrap;
  }

  .th:hover {
    background-color: #e9e9e9;
  }

  .th:last-child {
    border-right: 0;
  }

  .td-content {
    display: block;
  }

  .td {
    align-items: stretch;
    color: #424242;
    display: flex;
    flex-direction: column;
    font-size: 0.75rem !important;
    cursor: pointer;
    font-weight: 400;
    overflow: hidden;
    position: relative;
    white-space: nowrap;
  }

  .td:last-child {
    border-right: 0;
  }

  .tr .td:first-child {
    align-items: center;
    display: flex;
    justify-content: center;
    max-width: 40px !important;
  }

  .transition-fade-enter {
    opacity: 0;
  }

  .transition-fade-enter-active {
    opacity: 1;
    transition: opacity 300ms;
  }

  .transition-fade-exit {
    opacity: 1;
  }

  .transition-fade-exit-active {
    opacity: 0;
    transition: opacity 300ms;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CompanyAdmin/frontend-common/BulkUploader/Components/Table/style.css"],"names":[],"mappings":"AAAA;EACE;;IAEE,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,WAAW;;IAEX;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,cAAc;IACd,eAAe;IACf,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gCAAgC;;IAEhC;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;IAC/B,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;;;IAGE,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;IACb,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,kBAAkB;IAClB,0BAA0B;IAC1B,UAAU;IACV,UAAU;;IAEV;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE;oGACgG;EAClG;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;;;;IAIE,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gCAAgC;IAChC,+BAA+B;IAC/B,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;;IAEnB;MACE,cAAc;MACd,kBAAkB;MAClB,qBAAqB;MACrB,WAAW;IACb;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;AACF","sourcesContent":[".tableView-x {\n  .add-row,\n  .sort-button {\n    align-items: center;\n    color: #757575;\n    cursor: pointer;\n    display: flex;\n    font-size: 14px;\n    padding: 0.25rem 0.75rem;\n    width: 100%;\n\n    &:hover {\n      background-color: #eeeeee;\n    }\n  }\n\n  .add-row {\n    color: #9e9e9e;\n    cursor: pointer;\n    display: flex;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 0.5rem;\n    border-bottom: 1px solid #e0e0e0;\n\n    &:hover {\n      background-color: #e9e9e9;\n    }\n  }\n\n  .bg-white {\n    background-color: white;\n  }\n\n  .border-radius-md {\n    border-radius: 5px;\n  }\n\n  .cell-padding {\n    padding: 0.5rem;\n  }\n\n  .cursor-default {\n    cursor: default;\n  }\n\n  .cursor-pointer {\n    cursor: pointer;\n  }\n\n  .data-input {\n    background-color: white;\n    border: none;\n    box-sizing: border-box;\n    color: #424242;\n    flex: 1 1 auto;\n    font-size: 0.8rem;\n    height: 100%;\n    padding: 0.5rem;\n    resize: none;\n    white-space: pre-wrap;\n    width: 100%;\n  }\n\n  .d-flex {\n    display: flex;\n  }\n\n  .flex-1 {\n    flex: 1;\n  }\n\n  .flex-wrap-wrap {\n    flex-wrap: wrap;\n  }\n\n  .font-size-75 {\n    font-size: 0.75rem;\n  }\n\n  .font-weight-600 {\n    font-weight: 600;\n  }\n\n  .form-input {\n    background-color: #eeeeee;\n    border: none;\n    color: #424242;\n    font-size: 14px;\n    padding: 0.375rem;\n    /* border-radius: 4px; */\n  }\n\n  .form-input:focus {\n    box-shadow: 0 0 1px 2px #8ecae6;\n    outline: none;\n  }\n\n  .icon-margin {\n    margin-right: 4px;\n  }\n\n  .is-fullwidth {\n    width: 100%;\n  }\n\n  .noselect {\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n\n  .option-input,\n  .transition-fade-enter,\n  .transition-fade-exit {\n    background-color: transparent;\n    border: none;\n    font-size: 1rem;\n    outline: none;\n    width: 100%;\n  }\n\n  .overlay {\n    height: 100vh;\n    left: 0;\n    overflow: hidden;\n    position: fixed;\n    top: 0;\n    width: 100vw;\n    z-index: 2;\n  }\n\n  .resizer {\n    background: transparent;\n    cursor: col-resize;\n    display: inline-block;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    touch-action: none;\n    transform: translateX(50%);\n    width: 8px;\n    z-index: 1;\n\n    &:hover {\n      background-color: #8ecae6;\n    }\n  }\n\n  .shadow-5 {\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.12),\n      0 4px 6px rgba(0, 0, 0, 0.12), 0 8px 16px rgba(0, 0, 0, 0.12), 0 16px 32px rgba(0, 0, 0, 0.12);\n  }\n\n  .svg-gray svg {\n    stroke: #9e9e9e;\n  }\n\n  .svg-green {\n    color: #3e9140;\n  }\n\n  .svg-icon svg,\n  .svg-icon-sm svg,\n  .svg-180 svg,\n  .svg-text svg {\n    height: 1.5em;\n    position: relative;\n    width: 1.5em;\n  }\n\n  .svg-icon-sm svg {\n    height: 1.25em;\n    width: 1.25em;\n  }\n\n  .table {\n    border-spacing: 0;\n    margin-bottom: 10px;\n  }\n\n  .tableHeader {\n    background-color: #f5f5f5;\n    display: flex;\n  }\n\n  .text-align-right {\n    text-align: right;\n  }\n\n  .th,\n  .td {\n    border-bottom: 1px solid #e0e0e0;\n    border-right: 1px solid #e0e0e0;\n    margin: 0;\n  }\n\n  .th-content {\n    align-items: flex-start;\n    display: flex;\n    flex-direction: column;\n    justify-self: center;\n    padding: 0.5rem;\n    white-space: normal;\n\n    .subLabel {\n      color: #5f5f5f;\n      font-size: 0.75rem;\n      word-wrap: break-word;\n      width: 100%;\n    }\n  }\n\n  thead {\n    display: flex;\n  }\n\n  .th {\n    cursor: pointer;\n    font-size: 0.95rem;\n    font-weight: 500;\n    overflow: hidden;\n    position: relative;\n    white-space: nowrap;\n  }\n\n  .th:hover {\n    background-color: #e9e9e9;\n  }\n\n  .th:last-child {\n    border-right: 0;\n  }\n\n  .td-content {\n    display: block;\n  }\n\n  .td {\n    align-items: stretch;\n    color: #424242;\n    display: flex;\n    flex-direction: column;\n    font-size: 0.75rem !important;\n    cursor: pointer;\n    font-weight: 400;\n    overflow: hidden;\n    position: relative;\n    white-space: nowrap;\n  }\n\n  .td:last-child {\n    border-right: 0;\n  }\n\n  .tr .td:first-child {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    max-width: 40px !important;\n  }\n\n  .transition-fade-enter {\n    opacity: 0;\n  }\n\n  .transition-fade-enter-active {\n    opacity: 1;\n    transition: opacity 300ms;\n  }\n\n  .transition-fade-exit {\n    opacity: 1;\n  }\n\n  .transition-fade-exit-active {\n    opacity: 0;\n    transition: opacity 300ms;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
